<mat-expansion-panel id="vehicle-expansion" [expanded]="!isEditMode">
  <mat-expansion-panel-header>
    <mat-panel-title class="step-title">
      {{ 'testDrive.chooseVehicle' | translate}}
    </mat-panel-title>
    <mat-panel-description class="form-status">
      <span class="in-complete" *ngIf="!step.valid">Incomplete</span>
      <span class="complete" *ngIf="step.valid">Complete</span>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <form [formGroup]="step"
    *ngIf="!(isUserVehiclesLoading$ | async) && !(modelYearAndModelsLoading$ | async) ;else loader" autocomplete="off">
    <div id="select-vehicle-container">
      <div class="accordion">
        <div class="accordion-header">
          <div class="title">
            <div class="step-title anime-element anime-prime"> {{ title }}</div>
          </div>
          <div *ngIf="!(isEditMode$| async)" id="vehicle-type-switcher" (click)="toggleVehicleType()">
            {{ switcherText }}
            <span class="arrow"></span>
          </div>
        </div>
        <div class="accordion-panel">
          <ng-container *ngIf='isEditMode$ | async'>
            <div class="edit-mode-vehicle">
              <mat-icon class="mat-icon">info_outline</mat-icon>
                <span *ngIf="!showPartsField">{{ 'service.vehicleDetailsCanNotBeModifiedExceptMileage' | translate}}</span>
                <span *ngIf="showPartsField">{{ 'service.vehicleDetailsCanNotBeModifiedExceptMileageNPartsfields' | translate}}</span>
            </div>
          </ng-container>

          <!-- Own vehicle input form -->
          <ng-container *ngIf="isOwnVehicle">
            <div class="own-vehicle-error" *ngIf="vehicles.length > 1 || !step.value.mileage">
              {{step.errors?.required | translate}}
            </div>
            <div id="own-vehicles-container">
              <ng-container *ngIf="vehicles.length; else noVehicleFound">
                <div class="own-vehicle" *ngFor="let vehicle of vehicles">
                  <label>
                    <input type="radio" [value]="vehicle.vin" [checked]="step.value?.vin === vehicle.vin"
                      (change)="vehicleSelected(vehicle, vehicleCardComponent)" formControlName="vin" />
                    <div class="vehicle-card-container anime-element">
                      <app-learning-vehicle-card #vehicleCardComponent [preSelectedVin]="preSelectedVin"
                        [vehicle]="vehicle" [newvehicle]="newvehicle"
                        (fieldChange)="onVehicleFieldChange($event, vehicle)"
                        (toShowFooterDetails)="toShowFooterDetails($event)"
                        [editmode]="(isEditMode$ | async)"></app-learning-vehicle-card>
                    </div>
                  </label>
                </div>
              </ng-container>
              <ng-template #noVehicleFound>
                <div class="vehicle-not-found">
                  <mat-icon class="icon">info</mat-icon>
                  <div class="text">{{'service.vehiclesNotFound' | translate}}</div>
                  <div class="text-sec">
                    {{'otherTexts.thereAreNoVehiclesAssociatedWithTheCustomer' | translate}}
                    {{'otherTexts.pleaseChooseVehicleDetailsFromChooseAnotherVehicleSectionAbove' | translate}}
                  </div>
                </div>
              </ng-template>
            </div>

            <!-- Parts Fields Section -->
            <div *ngIf="showPartsField && isOwnVehicle && !isVehicleAtOwnedVehicles()" class="parts-fields-section">
              <!-- Input: Order ref -->
              <div class="field-input">
                <label>{{ 'parts.orderRef' | translate}}</label>
                <mat-form-field class="mat-input-container anime-element" appearance="outline">
                  <input matInput formControlName="orderRefNumber" />
                </mat-form-field>
              </div>

              <!-- Input: Dealer Order -->
              <div class="field-input">
                <label>{{ 'parts.dealerOrder' | translate}}</label>
                <mat-form-field class="mat-input-container anime-element" appearance="outline">
                  <input matInput formControlName="dealerOrderNumber" />
                  <mat-error
                    *ngIf="step.controls.orderRefNumber.errors?.requiredOneOf || step.controls.dealerOrderNumber.errors?.requiredOneOf">
                    {{ 'parts.orderRefOrDealerOrderRequired' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </ng-container>

          <!-- Different vehicle input form -->
          <ng-container *ngIf="!isOwnVehicle || (isEditMode && isVehicleAtOwnedVehicles())">
            <div id="different-vehicle-container">
              <div class="column-section-1 p-0">
                <div class="make-year-model-container">

                  @if(this.srcInternal === 'signal') {
                  <!-- Input: make -->
                  <div class="field-input">
                    <label>{{ 'service.make' | translate}}</label>
                    <mat-form-field class="mat-input-container anime-element" appearance="outline">
                      <input matInput [placeholder]="'service.selectAMake' | translate" formControlName="make"
                        [value]="step.controls.make" [readonly]="srcInternal === 'signal'" />
                    </mat-form-field>
                  </div>

                  <!-- based on make show  text input -->
                  <ng-container *ngIf="!isMakeOther; else textInputForOther">
                    <!-- Input: Year -->
                    <div class="field-input">
                      <label>{{ 'service.modelYear' | translate }}</label>
                      <mat-form-field class="mat-input-container anime-element anime-sec" appearance="outline">
                        <input matInput [placeholder]="'service.selectAYear' | translate" formControlName="year"
                          [value]="step.controls.year" [readonly]="srcInternal === 'signal'" />
                      </mat-form-field>
                    </div>

                    <!-- Input: Model -->
                    <div class="field-input">
                      <label>{{ 'testDrive.model' | translate}}</label>
                      <mat-form-field class="mat-input-container anime-element anime-sec" appearance="outline">
                        <input matInput [placeholder]="'service.selectAModel' | translate" formControlName="model"
                          [value]="step.controls.model" [readonly]="srcInternal === 'signal'" />
                      </mat-form-field>
                    </div>
                  </ng-container>

                  }

                  @else {
                  <ng-container *ngIf="isEditMode">

                    <!-- Input: make -->
                    <div class="field-input">
                      <label>{{ 'service.make' | translate}}</label>
                      <mat-form-field class="mat-input-container anime-element" appearance="outline">
                        <input matInput [placeholder]="'service.selectAMake' | translate" formControlName="make"
                          [value]="step.controls.make" />
                      </mat-form-field>
                    </div>

                    <!-- based on make show  text input -->
                    <ng-container *ngIf="!isMakeOther; else textInputForOther">
                      <!-- Input: Year -->
                      <div class="field-input">
                        <label>{{ 'service.modelYear' | translate }}</label>
                        <mat-form-field class="mat-input-container anime-element anime-sec" appearance="outline">
                          <input matInput [placeholder]="'service.selectAYear' | translate" formControlName="year"
                            [value]="step.controls.year" />
                        </mat-form-field>
                      </div>

                      <!-- Input: Model -->
                      <div class="field-input">
                        <label>{{ 'testDrive.model' | translate}}</label>
                        <mat-form-field class="mat-input-container anime-element anime-sec" appearance="outline">
                          <input matInput [placeholder]="'service.selectAModel' | translate" formControlName="model"
                            [value]="step.controls.model" />
                        </mat-form-field>
                      </div>
                    </ng-container>


                  </ng-container>

                  <ng-container *ngIf="!isEditMode">

                    <!-- Input: make -->
                    <div class="field-input">
                      <label>{{ 'service.make' | translate}}</label>
                      <mat-form-field class="mat-input-container anime-element" appearance="outline">
                        <mat-select formControlName="make" [placeholder]="'service.selectAMake' | translate">
                          <mat-option *ngFor="let make of makes" [value]="make.name">
                            {{ make.name | titlecase}}
                          </mat-option>
                        </mat-select>
                        <mat-error *ngIf="step.controls.make.errors?.required">{{ 'service.makeIsRequired' |
                          translate}}</mat-error>
                      </mat-form-field>
                    </div>

                    <!-- based on make show drop down or text input -->
                    <ng-container *ngIf="!isMakeOther; else textInputForOther">

                      <!-- Input: Year -->
                      <div class="field-input">
                        <label>{{ 'service.modelYear' | translate}}</label>
                        <mat-form-field class="mat-input-container anime-element anime-sec" appearance="outline">
                          <mat-select formControlName="year" [placeholder]="'service.selectAYear' | translate">
                            <mat-option *ngFor="let s of yearmodels" [value]="s">
                              {{ s }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="step.controls.year.errors?.required">{{ 'service.yearIsRequired' |
                            translate}}</mat-error>
                        </mat-form-field>
                      </div>

                      <!-- Input: Model -->
                      <div class="field-input">
                        <label>{{ 'testDrive.model' | translate}}</label>
                        <mat-form-field class="mat-input-container anime-element anime-sec" appearance="outline">
                          <mat-select formControlName="model" [placeholder]="'service.selectAModel' | translate">
                            <mat-option *ngFor="let model of models" [value]="model">
                              {{ model }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="step.controls.model.errors?.required">{{ 'service.modelIsRequired' |
                            translate}}</mat-error>
                        </mat-form-field>
                      </div>
                    </ng-container>
                  </ng-container>
                  }

                  <ng-template #textInputForOther>
                    <!-- Input: Year -->
                    <div class="field-input">
                      <label>{{ 'service.makeName' | translate }}</label>
                      <mat-form-field class="mat-input-container anime-element anime-sec" appearance="outline">
                        <input matInput [placeholder]="'service.enterTheMakeName' | translate"
                          formControlName="otherMake" [readonly]="srcInternal === 'signal'" />
                        <mat-error *ngIf="step.controls.otherMake.errors?.required">{{ 'service.makeNameIsRequired' |
                          translate}}</mat-error>
                      </mat-form-field>
                    </div>

                    <!-- Input: Year -->
                    <div class="field-input">
                      <label>{{ 'service.modelYear' | translate}}</label>
                      <mat-form-field class="mat-input-container anime-element anime-sec" appearance="outline">
                        <input matInput [placeholder]="'service.enterModelYear' | translate" formControlName="year"
                          aspNumberOnly [readonly]="srcInternal === 'signal'" />
                        <mat-error *ngIf="step.controls.year.errors?.required">{{ 'service.yearIsRequired' |
                          translate}}</mat-error>
                      </mat-form-field>
                    </div>

                    <!-- Input: Model -->
                    <div class="field-input">
                      <label>{{ 'testDrive.model' | translate}}</label>
                      <mat-form-field class="mat-input-container anime-element anime-sec" appearance="outline">
                        <input matInput [placeholder]="'service.enterModel' | translate" formControlName="model"
                          [readonly]="srcInternal === 'signal'" />
                        <mat-error *ngIf="step.controls.model.errors?.required">{{ 'service.modelIsRequired' |
                          translate}}</mat-error>
                      </mat-form-field>
                    </div>
                  </ng-template>
                </div>
                <!-- make-year-model-container -->

                <div id="or" class="anime-element">{{ 'testDrive.or' | translate}}</div>

                <!-- Input: VIN -->
                <div class="vin-container"
                  [ngClass]="{'license-field-displayed': filterOptionSelected === 'licensePlate'}">
                  <div class="field-input">
                    <ng-container *ngIf="filterOptions?.length > 1; else singleFilterOption">
                      <mat-select class="filter-option" [placeholder]="'service.vin' | translate"
                        [(value)]="filterOptionSelected" (selectionChange)="onSelectingFilterOption($event.value)"
                        [disabled]="isEditMode">
                        <mat-select-trigger>
                          {{ selectedOption | translate }} <span *ngIf="!showPartsField" style="color: red">*</span>
                        </mat-select-trigger>
                        <mat-option *ngFor="let option of filterOptions" [value]="option.filterId">
                          {{ option?.filterName }}
                        </mat-option>
                      </mat-select>
                    </ng-container>
                    <ng-template #singleFilterOption>
                      <label class="filter-option">
                        {{ selectedOption | translate }} <span *ngIf="!showPartsField" style="color: red">*</span>
                      </label>
                    </ng-template>
                    <mat-form-field class="mat-input-container anime-element" appearance="outline"
                      *ngIf="filterOptionSelected === 'vin'">
                      <input matInput placeholder="{{'service.enter17digitVIN' | translate}}" formControlName="vin"
                        [required]="isVinMandate" [readonly]="srcInternal === 'signal'" />
                      <mat-error *ngIf="step.controls.vin.errors?.required">{{'service.vinIsRequired' |
                        translate}}</mat-error>
                      <mat-error
                        *ngIf=" step.controls.vin.errors?.pattern17DigitAndAlphaNumeric">{{step.controls.vin.errors?.pattern17DigitAndAlphaNumeric
                        | translate}}</mat-error>
                      <mat-error
                        *ngIf=" step.controls.vin.errors?.pattern17Digit">{{step.controls.vin.errors?.pattern17Digit |
                        translate}}</mat-error>
                      <mat-error
                        *ngIf=" step.controls.vin.errors?.patternAlphaNumeric">{{step.controls.vin.errors?.patternAlphaNumeric
                        | translate}}</mat-error>
                    </mat-form-field>
                    <mat-form-field class="mat-input-container anime-element" appearance="outline"
                      *ngIf="filterOptionSelected === 'licensePlate'">
                      <input type="text" matInput [placeholder]="'service.enterLicensePlate' | translate"
                        formControlName="licensePlate" autocomplete="off" minlength="2" maxlength="10">
                      <mat-error *ngIf="hasError('licensePlate','required')">{{ 'service.licensePlateIsRequired' |
                        translate}}</mat-error>
                      <mat-error *ngIf="hasError('licensePlate','minlength')">{{ 'service.licensePlateMinlength' |
                        translate}}</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="license-field" *ngIf="filterOptionSelected === 'licensePlate'">
                    <label class="mb-.5">{{'service.state' | translate}}<span style="color: red">*</span></label>
                    <mat-form-field class="mat-input-container anime-element" appearance="outline">
                      <input type="text" placeholder="Enter State" #state matInput formControlName="state"
                        [matAutocomplete]="auto" (input)="filter(state.value)">
                      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayStateName"
                        (optionSelected)="onOptionSelected()">
                        <mat-option *ngFor="let option of filteredStatesList" [value]="option.abbreviation"
                          title="{{option.name}}">
                          {{option.name}}
                        </mat-option>
                      </mat-autocomplete>
                      <mat-error *ngIf="hasError('state','required')">{{ 'service.stateIsRequired' |
                        translate}}</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <app-loading *ngIf="isSubmitting" loadingSymbol="dots" color="var(--dashboard-primary-color)"
                  [size]=".6"></app-loading>
                <div *ngIf="!isSubmitting">
                  <p *ngIf="hasExistingAppt" class="info-text error">{{ existingApptText }}</p>
                  <p *ngIf="vehicleNotFound" class="info-text error">{{ 'service.noVehiclesForLicensePlate' |
                    translate}}</p>
                  <p *ngIf="vehicleFound" class="info-text success">{{ 'service.foundVehiclesForLicensePlate' |
                    translate}}</p>
                </div>
                <!-- <div class="vin-container">
                  <div class="field-input">
                    <label>{{'service.enterTheVin' | translate}}<span *ngIf="isVinMandate" style="color: red">*</span></label>
                    <mat-form-field class="mat-input-container anime-element" appearance="outline">
                    <input
                      matInput
                      placeholder="{{'service.enter17digitVIN' | translate}}"
                      formControlName="vin"
                      [required]="isVinMandate"
                    />
                    <mat-error *ngIf="step.controls.vin.errors?.required">{{'service.vinIsRequired' | translate}}</mat-error>
                    <mat-error
                      *ngIf=" step.controls.vin.errors?.pattern17DigitAndAlphaNumeric"
                    >{{step.controls.vin.errors?.pattern17DigitAndAlphaNumeric | translate}}</mat-error>
                    <mat-error
                      *ngIf=" step.controls.vin.errors?.pattern17Digit"
                    >{{step.controls.vin.errors?.pattern17Digit | translate}}</mat-error>
                    <mat-error
                      *ngIf=" step.controls.vin.errors?.patternAlphaNumeric"
                    >{{step.controls.vin.errors?.patternAlphaNumeric | translate}}</mat-error>
                  </mat-form-field>
                  <div *ngIf="hasExistingAppt" style="font-size: 14px;color: red;padding: 0 1em;">
                    <sup >   {{existingApptText}}</sup>
                  </div>
                  </div>
                </div> -->

                <!-- Input: Mileage -->
                <div *ngIf="showMileageField">
                  <div class="anime-element">
                    <div class="mileage-input-title">{{'service.enterTheMileage' | translate}}
                      <span style="color: red">*</span>
                    </div>
                    <div class="mileage-input-hint">
                      {{'service.customerDonTKnowExactMileageGiveUsAnApproximateOne' | translate}}
                    </div>
                  </div>
                  <mat-form-field class="mat-input-container anime-element" appearance="outline">
                    <input matInput placeholder="{{milesPlaceholder}}" formControlName="mileage" aspNumberOnly
                      (input)="onKeyPress($event)" />
                    <mat-error *ngIf="step.controls.mileage.errors?.required">{{ milesIsRequired }}</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="column-section-2 p-0" *ngIf="showPartsField">
                <!-- Input: Order ref -->
                <div class="field-input">
                  <label>{{ 'parts.orderRef' | translate}}</label>
                  <mat-form-field class="mat-input-container anime-element" appearance="outline">
                    <input matInput formControlName="orderRefNumber" [value]="step.controls.orderRefNumber" />
                  </mat-form-field>
                </div>

                <!-- Input: Dealer Order -->
                <div class="field-input">
                  <label>{{ 'parts.dealerOrder' | translate}}</label>
                  <mat-form-field class="mat-input-container anime-element" appearance="outline">
                    <input matInput formControlName="dealerOrderNumber"
                      [value]="step.controls.dealerOrderNumber" />
                    <mat-error
                      *ngIf="step.controls.orderRefNumber.errors?.requiredOneOf || step.controls.dealerOrderNumber.errors?.requiredOneOf">
                      {{ 'parts.orderRefOrDealerOrderRequired' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <!-- accordion panel -->
      </div>
    </div>
  </form>
  <ng-template #loader>
    <div id="schedule-rotation-loader">
      <app-loading loadingSymbol="dots" text="{{ 'testDrive.loading' | translate | titlecase}}"
        color="var(--dashboard-primary-color)" size="1">
      </app-loading>
    </div>
  </ng-template>
</mat-expansion-panel>